module.exports = __webpack_public_path__ + "static/media/es_how-it-work.4907c540.png";